import imgRealEstateViewIntro from 'images/img_real_estate_view_intro.svg';

import { PromoCtaButton } from './PromoFeatureCard';
import {
  IntroBody,
  IntroCopy,
  IntroIllustration,
  IntroRoot,
  IntroTitle,
} from './RealEstateViewIntroBanner.styles';

export type RealEstateViewIntroBannerProps = {
  onViewNow: () => void;
};

export function RealEstateViewIntroBanner({
  onViewNow,
}: RealEstateViewIntroBannerProps) {
  return (
    <IntroRoot id="real-estate-view-intro">
      <IntroIllustration aria-hidden>
        <img src={imgRealEstateViewIntro} alt="" width={140} height={139} />
      </IntroIllustration>
      <IntroCopy>
        <IntroTitle variant="h3">Introducing Real Estate View!</IntroTitle>
        <IntroBody variant="body1">
          You can now see your property reports in the view of a “Homebuyer” or
          “Real-Estate Professional”.
        </IntroBody>
        <PromoCtaButton
          variant="contained"
          color="primary"
          onClick={onViewNow}
          data-cy="real-estate-view-intro-cta"
          sx={{ marginTop: 1.5 }}
        >
          View Now
        </PromoCtaButton>
      </IntroCopy>
    </IntroRoot>
  );
}
